export default {
  'avatar.category': 'Catégorie inconnu',
  'avatar.community': 'Communauté inconnue',
  'avatar.user': 'User inconnu',
} as const;
